import Backbone from 'backbone';

import template from './suggestedSetting.pug';

export class SuggestedSettingContextualAttributeView extends Backbone.View {
  initialize({
    i18n,
  }) {
    this.i18n = i18n;
  }

  render({
    showDeliveryStatusPopup,
  }) {
    const message = this.i18n.getString('Details_View_Suggested_Setting_Context_Attribute');
    this.$el.html(template({ message }));

    showDeliveryStatusPopup(this.el.outerHTML);
    return this;
  }
}
